'use client';

import { useRef } from 'react';
import { Heart } from 'lucide-react';
import Image from 'next/image';

export default function NarrativeFlowChart() {
  const ref = useRef<HTMLDivElement>(null);

  return (
    <section className="py-20 bg-white relative">
      <div className="container-custom">
        <div ref={ref} className="relative">
          <div className="text-center mb-16">
            <h2 className="heading-2 text-oxford mb-4">
              Breaking the Cycle of Poverty
            </h2>
            <p className="body-text text-oxford/80 max-w-3xl mx-auto">
              In India, <strong>94 million children</strong> risk being trapped in poverty despite education. Without intervention, they face a lifetime of struggle.
            </p>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-8 max-w-4xl mx-auto">
              <div className="bg-red-50 p-4 rounded-lg border-l-4 border-red-500">
                <p className="text-sm font-medium text-red-800">
                  <strong>47%</strong> of students drop out before completing secondary education
                </p>
              </div>
              <div className="bg-red-50 p-4 rounded-lg border-l-4 border-red-500">
                <p className="text-sm font-medium text-red-800">
                  <strong>76%</strong> of graduates lack skills needed for meaningful employment
                </p>
              </div>
              <div className="bg-red-50 p-4 rounded-lg border-l-4 border-red-500">
                <p className="text-sm font-medium text-red-800">
                  <strong>3 generations</strong> of poverty perpetuated without intervention
                </p>
              </div>
            </div>
          </div>

          {/* Rohan's Story */}
          <div
            className="mt-12 bg-oxford text-ivory p-8 md:p-12 rounded-lg"
          >
            <div className="flex flex-col md:flex-row items-center gap-8">
              <div className="w-full md:w-1/2 aspect-[4/3] relative rounded-lg overflow-hidden">
                <img
                  src="/page1/rohans_story_lq_2.jpeg"
                  alt="Rohan's journey"
                  sizes="(max-width: 768px) 100vw, 50vw"
                  className="object-cover rounded-lg"
                />
              </div>
              <div className="md:w-1/2">
                <h3 className="font-heading text-2xl mb-4">Rohan's Story</h3>
                <p className="text-ivory/80 mb-4">
                  Rohan represents millions of young Indians trapped in a system that fails them. Without our intervention, he faces a future of exploitation, instability, and continued poverty.
                </p>
                <p className="text-ivory/80 mb-4">
                  Like 82% of male and 92% of female workers in India, he will likely earn less than ₹10,000 per month — condemning his future children to the same fate, perpetuating a cycle of despair for generations.
                </p>
                <p className="text-ivory/80 font-medium">
                  <strong className="text-butterscotch">Every day we delay, another child's future dims.</strong> At Micro Leaps, we're breaking this cycle by ensuring education truly empowers children like Rohan.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
} 